module.exports = __webpack_public_path__ + "img/team-worked-5.58d408b6.png";